import { PropsWithChildren } from "react";
import cn from "classnames";

import styles from "./BlankPageWrapper.module.scss";

export const BlankPageWrapper = ({ children, isPadded = true }: PropsWithChildren & {isPadded?: boolean}) => {
  const pageClasses = cn(styles["blank-page-wrapper"], { [styles["padded"]]: isPadded });

  return (
    <div className={pageClasses}>{children}</div>
  );
};
